import React from "react";

export default function ButtonLoader({ btnColor = "dark" }) {
  return (
    <div
      className={"btn-loader"}
      style={{ borderColor: btnColor == "light" ? "#fff" : "#010101" }}
    ></div>
  );
}
